/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { getAuth } from '../../../modules/auth/core/AuthHelpers'

const DatosConfirmacion: React.FC = () => {
  const usuario = getAuth();
  console.log(usuario?.usuarioGc_Track?.correo)

  return (
    <>
      <div className='d-flex flex-row justify-content-between'>
        <div className='col-5 d-flex flex-column justify-content-between'>
          <div className='card-header border-4 py-0 border-0 d-flex justify-content-center'>
            <h3 className='fw-bolder fs-3 m-0'> Datos del Solicitante </h3>
          </div>

          <div className="col-12 mb-3 d-flex justify-content-between">
            <label htmlFor="inputNombre" className="required form-label fw-bold fs-5 d-flex align-self-center">Nombre</label>
            <input type="text" className="form-control fs-5 py-1 form-control-solid" placeholder={usuario?.usuarioGc_Track?.nombreCompleto} disabled />
          </div>
          <div className="col-12 mb-3 d-flex justify-content-between">
            <label htmlFor="inputCorreo" className="required form-label fw-bold fs-5 d-flex align-self-center">Correo</label>
            <input type="email" className="form-control fs-5 py-1 form-control-solid" placeholder={usuario?.usuarioGc_Track?.correo} disabled />
          </div>
          <div className="col-12 mb-3 d-flex justify-content-between">
            <label htmlFor="inputEmpresa" className="required form-label fw-bold fs-5 d-flex align-self-center">Empresa</label>
            <input type="text" className="form-control fs-5 py-1 form-control-solid" placeholder={usuario?.usuarioGc_Track?.organizacion} disabled />
          </div>

        </div>
        <div className='col-6 d-flex flex-column justify-content-between'>
          <div className='card-header border-4 py-0 border-0 d-flex justify-content-center'>
            <h3 className='fw-bolder fs-3 m-0'> Datos del Envío </h3>
          </div>
          <div className="col-12 mb-3 d-flex justify-content-between">
            <label htmlFor="inputDestino" className="required form-label fw-bold fs-5 d-flex align-self-center">Ubicación</label>
            <select className="form-select fs-5 py-1" aria-label="Select example">
              <option> </option>
              <option value="1">Sucursal 1</option>
              <option value="2">Sucursal 2</option>
              <option value="3">Sucursal 3</option>
              <option value="4">Personalizado</option>
            </select>
          </div>
          <div className='d-flex flex-row justify-content-between'>
            <div className="col-5 mb-3 d-flex justify-content-between">
              <label htmlFor="inputCiudad" className="required form-label fw-bold fs-5 d-flex align-self-center">Ciudad</label>
              <input type="text" className="form-control fs-5 py-1 form-control-solid" placeholder="Mexicali" disabled />
            </div>
            <div className="col-6 mb-3 d-flex justify-content-between">
              <label htmlFor="inputPais" className="required form-label fw-bold fs-5 d-flex align-self-center">País</label>
              <input type="text" className="form-control fs-5 py-1 form-control-solid" placeholder="México" disabled />
            </div>
          </div>
          <div className="col-12 mb-3 d-flex justify-content-between">
            <label htmlFor="inputRazon" className="required form-label fw-bold fs-5 d-flex align-self-center">Dirección</label>
            <input type="text" className="form-control fs-5 py-1 form-control-solid" placeholder="Hacienda del Río ####" disabled />
          </div>
        </div>
      </div>

      <div className='separator separator-dashed my-6'></div>



    </>

  )
}

export { DatosConfirmacion }
